import React from 'react';
import { connect } from 'react-redux';
import '@ant-design/compatible/assets/index.css';
import {
	Layout,
	Row,
	Col,
	Button,
	Card,
	message,
	Modal,
	Popconfirm,
	Spin,
	Dropdown,
	Menu,
	Rate,
} from 'antd';
import { EmptyState } from '../empty_state/EmptyState';
import PaginatedReduxTable from '../paginated_redux_table/PaginatedReduxTable';
import {
	addNewSupplierForBuyers,
	createSupplierPrivateNetworkBulkForBuyer,
	createSupplierPrivateNetworkBulkForSupplier,
	deleteBuyerSupplierRelationshipBySupplierFacilityIdForBuyer,
	deleteBuyerSupplierRelationshipBySupplierFacilityIdForSupplier,
	downloadAllSuppliers,
	downloadFirstRankSuppliers,
	fetchSuppliersForBuyers,
	getUploadRankBulkStatus,
	inviteSupplierUserFromBuyer,
	supplierPrivateNetworkGroupedUpdateForBuyer,
	supplierPrivateNetworkGroupedUpdateForSupplier,
	supplierPrivateNetworksV2ForBuyer,
	supplierPrivateNetworksV2ForSupplier,
	supplierPrivateNetworkV2UpdateForBuyer,
	supplierPrivateNetworkV2UpdateForSupplier,
} from '../../thunks/supplier_private_networks_thunks';
import { FlexibleImageAvatar } from '../flexible-image-avatar/FlexibleImageAvatar';
import { AddressDisplay } from '../address_display/AddressDisplay';
import { capitalizeEachWord, stringArrToList } from '../../utils/DataFormatterUtils';
import {
	isAdminUser,
	nullSafeGet,
	nullSafeGetOrElse,
	stopDefaultEvents,
} from '../../utils/DataAccessUtils';
import SupplierPrivateNetworkCreateForm from '../supplier_private_network_create_form/SupplierPrivateNetworkCreateForm';
import SupplierPrivateNetworkEditForm from '../supplier_private_network_edit_form/SupplierPrivateNetworkEditForm';
import SubnavBar from '../subnav_bar/SubnavBar';
import { AdvancedFilters } from '../advanced_filters/AdvancedFilters';
import { SUPPLIER_PRIVATE_NETWORKS_CRUD_ACTION_CREATORS } from '../../actions/supplier_private_networks_actions';
import {
	locationsRestCrudThunksForBuyer,
	locationsRestCrudThunksForSupplier,
} from '../../thunks/locations_thunks';
import SimilarSuppliersPanel, {
	getSimilarSuppliersTitle,
} from '../similar_suppliers_panel/SimilarSuppliersPanel';
import InviteSupplierForm from '../invite_supplier_form/InviteSupplierForm';
import SelectedFilters from '../selected_filters_pills/SelectedFilters';
import { FILTER_CONFIG_NAMES, ROLE_TYPES } from '../../utils/DataConstants';
import {
	ALL_SUPPLIER_TYPES,
	getSupplierTypeFlags,
	getSupplierTypeFromFlags,
	SUPPLIER_TYPE_LABELS,
	SUPPLIER_TYPE_TAB_LABELS,
	SUPPLIER_TYPES,
} from '../../utils/SupplierTypeUtils';
import { withRouter } from 'react-router';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { isInternalTech, PERMISSION_NAMES } from '../../utils/AuthUtils';
import { getAllSupplierPrivateNetworkEntities } from '../supplier_private_network_create_form/supplier_private_network_utils';
import { DownloadOutlined, DownOutlined } from '@ant-design/icons';
import FirstRankSupplierUploadButton from './FirstRankSupplierUploadButton';
import {
	SuppliersPendingApprovalsIndicator,
	SuppliersRequestToAddButton,
} from './SuppliersRequestToAddActions';
import {
	problemTypesHeirarchicalForBuyer,
	problemTypesHeirarchicalForSupplier,
} from '../../thunks/problem_types_thunks';
import OWButtonWithSupplierManagedLock from '../common/OWButtonWithSupplierManagedLock';
import { OWSubTabs } from '../ow_sub_tabs/OWSubTabs';
import { getPrivateNetworkFilterConfig } from '../../utils/PrivateNetworkFilterUtils';
import { BUYER_ADMIN, SUPER_ADMIN, SUPPLIER_ADMIN } from '../roles/roles';
import RatingComponent from '../RatingComponent';

const { Content } = Layout;
const queryString = require('qs');
require('./PrivateNetworkIndexPage.less');

const SUPPLIER_PRIVATE_NETWORKS_INDEX_TARGET_COLLECTION = 'supplierPrivateNetworksIndex';
const SUPPLIER_PRIVATE_NETWORKS_SEARCH_TARGET_COLLECTION = 'supplierPrivateNetworksSearch';

// Tabs that split the network by supplier type. The active tab is stored as the
// isInternalTeam/isLandlord filter pair rather than as a tab key of its own.
const THIRD_PARTY_SUPPLIERS_TAB_KEY = SUPPLIER_TYPES.THIRD_PARTY;
const INTERNAL_SUPPLIERS_TAB_KEY = SUPPLIER_TYPES.INTERNAL;
const LANDLORD_SUPPLIERS_TAB_KEY = SUPPLIER_TYPES.LANDLORD;

const SUPPLIER_TYPE_SUB_TABS = [
	ALL_SUPPLIER_TYPES,
	INTERNAL_SUPPLIERS_TAB_KEY,
	THIRD_PARTY_SUPPLIERS_TAB_KEY,
	LANDLORD_SUPPLIERS_TAB_KEY,
].map((supplierType) => ({
	key: supplierType,
	label: SUPPLIER_TYPE_TAB_LABELS[supplierType],
}));

class PrivateNetworkIndexPage extends React.Component<any, any> {
	initialPagination: any = { current: 1, pageSize: 10 };
	initialFilters: any = {};
	formRefs: any;

	constructor(props) {
		super(props);
		const { updateSupplierPrivateNetworksFilters, location, history, userType } = props;
		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const queryParams = queryString.parse(searchString);
		const {
			current,
			pageSize,
			total,
			sort_by,
			order,
			// Keys the supplier-type tabs used in earlier revisions. Every unrecognised query param
			// becomes a filter and is written straight back to the URL, so drop them rather than let
			// an older link carry a stale classification alongside the current one.
			supplierType,
			relationshipType,
			...networkFilters
		} = queryParams;
		this.initialPagination = { current: current ? current : 1, pageSize: pageSize ? pageSize : 10 };
		this.initialFilters =
			networkFilters && Object.keys(networkFilters).length > 0
				? {
						...networkFilters,
				  }
				: {};
		// No type flags in the URL means the All tab, which is the first-load default — nothing to
		// seed here, since All is the absence of the filter pair.
		this.formRefs = {};
		updateSupplierPrivateNetworksFilters(
			this.initialFilters,
			SUPPLIER_PRIVATE_NETWORKS_INDEX_TARGET_COLLECTION
		);
		history.push(
			`/${userType}/suppliers/overview/privateNetwork?${new URLSearchParams(location.search)}`
		);

		this.state = {
			supplierPrivateNetworkCreateFormVisible: false,
			supplierPrivateNetworkEditFormVisible: false,
			supplierFacilityId: undefined,
			supplierFacility: null,
			infoModalVisible: false,
			selectSupplierModalVisible: false,
			inviteSupplierModalVisible: false,
			messageModalVisible: false,
			selectSuppliers: [],
			supplierInfo: {},
			removingFacilityId: null,
			updatingPrivateNetwork: false,
			creatingPrivateNetwork: false,
			downloading: false,
			addSupplierType: THIRD_PARTY_SUPPLIERS_TAB_KEY,
		};
	}

	componentDidMount() {}

	saveFormRef = (formName) => (formRef) => {
		this.formRefs[formName] = formRef;
	};

	// The current list query travels along as backlinkParams so the detail page's back link
	// returns to the tab and filters the user came from.
	goToSupplierDetailPage = (supplierFacilityId) => {
		const { history, location, userType } = this.props;
		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		let detailUrl = `/${userType}/suppliers/detail/${supplierFacilityId}`;
		if (searchString && searchString.length > 0) {
			detailUrl = detailUrl.concat(`?backlinkParams=${encodeURIComponent(searchString)}`);
		}
		history.push(detailUrl);
	};

	handleSupplierPrivateNetworkCreateSubmit = () => {
		const { createSupplierPrivateNetworkBulk, currentUser, inviteSupplierUser } = this.props;
		const { supplierInfo } = this.state;
		const form = this.formRefs['supplierPrivateNetworkCreateForm'].props.form;
		form.validateFields((err, values) => {
			if (err) {
				return;
			}

			this.setState({ creatingPrivateNetwork: true });

			const allSNs = getAllSupplierPrivateNetworkEntities(values);

			createSupplierPrivateNetworkBulk(allSNs)
				.then(() => {
					this.setState({ supplierPrivateNetworkCreateFormVisible: false });
					if (supplierInfo.primaryContactEmail) {
						inviteSupplierUser(
							values.supplierFacilityId,
							currentUser.email,
							supplierInfo.primaryContactEmail,
							supplierInfo.primaryContactFirstName,
							supplierInfo.primaryContactLastName
						).then(() => {
							message.success(
								`${supplierInfo.primaryContactFirstName} ${supplierInfo.primaryContactLastName} has been sent an invite to join OpenWrench at the email address: ${supplierInfo.primaryContactEmail}`
							);
						});
					}
					// Land on the new supplier rather than back on the list — the list refetches
					// anyway when the user follows the back link.
					this.goToSupplierDetailPage(values.supplierFacilityId);
				})
				.finally(() => this.setState({ creatingPrivateNetwork: false }));
		});
	};

	handleSupplierPrivateNetworkCreateCancel = (e) => {
		this.setState({
			supplierPrivateNetworkCreateFormVisible: false,
		});
		const form = this.formRefs['supplierPrivateNetworkCreateForm'].props.form;
		form.resetFields();
	};

	showSupplierPrivateNetworkCreateModal = (record) => {
		this.setState({
			supplierPrivateNetworkCreateFormVisible: true,
		});
	};

	handleSupplierTypeTabChange = (activeKey) => {
		const { updateSupplierPrivateNetworksFilters, supplierPrivateNetworks } = this.props;
		const currentFilters = nullSafeGetOrElse(
			`${SUPPLIER_PRIVATE_NETWORKS_INDEX_TARGET_COLLECTION}.filters`,
			supplierPrivateNetworks,
			{}
		);
		// The All tab clears the pair, so both flags are optional rather than always boolean.
		const updatedFilters: {
			isInternalTeam?: boolean;
			isLandlord?: boolean;
			relationshipStatus?: string;
		} = getSupplierTypeFlags(activeKey);
		// "Self Managed" is hidden only on the Internal tab, so clear it when switching
		// there to avoid a stuck filter the user can no longer see or change.
		if (
			activeKey === INTERNAL_SUPPLIERS_TAB_KEY &&
			currentFilters.relationshipStatus === 'SelfManaged'
		) {
			updatedFilters.relationshipStatus = undefined;
		}
		updateSupplierPrivateNetworksFilters(
			updatedFilters,
			SUPPLIER_PRIVATE_NETWORKS_INDEX_TARGET_COLLECTION
		);
	};

	refreshSupplierPrivateNetwork = () => {
		const { fetchSupplierPrivateNetworkV2, supplierPrivateNetworks } = this.props;
		fetchSupplierPrivateNetworkV2(
			null,
			SUPPLIER_PRIVATE_NETWORKS_INDEX_TARGET_COLLECTION,
			this.initialPagination,
			nullSafeGetOrElse('supplierPrivateNetworksIndex.sorting', supplierPrivateNetworks, {}),
			nullSafeGetOrElse('supplierPrivateNetworksIndex.filters', supplierPrivateNetworks, {})
		);
	};

	handleSupplierPrivateNetworkEditSubmit = (values) => {
		this.setState({ updatingPrivateNetwork: true });
		const { updateGroupedSupplierPrivateNetwork } = this.props;
		const locationIdSeq = values.allLocations
			? []
			: nullSafeGet('locationIds.0', values)
			? values.locationIds
			: undefined;
		const problemTypeIdSeq = values.allProblemTypes
			? []
			: nullSafeGet('problemTypeIds.0', values)
			? values.problemTypeIds
			: undefined;

		const noLocationOrProblemTypeAccess = !locationIdSeq && !problemTypeIdSeq;

		const entity = {
			supplierFacilityId: values.supplierFacilityId,
			...(!noLocationOrProblemTypeAccess && { problemTypeIdSeq }),
			...(!noLocationOrProblemTypeAccess && { locationIdSeq }),
			noLocationOrProblemTypeAccess,
			buyerCompanyId: values.buyerCompanyId,
		};

		const fn = updateGroupedSupplierPrivateNetwork(values.supplierFacilityId, entity);

		Promise.all([fn])
			.then(() => {
				this.setState({ supplierPrivateNetworkEditFormVisible: false });
				this.refreshSupplierPrivateNetwork();
				message.success(`updated supplier in your private network.`);
			})
			.finally(() => this.setState({ updatingPrivateNetwork: false }));
	};

	handleSupplierPrivateNetworkEditCancel = (e) => {
		this.setState({
			supplierPrivateNetworkEditFormVisible: false,
			supplierFacilityId: null,
			supplierFacility: null,
		});
	};

	removeFromSupplierPrivateNetwork = (supplierFacilityId) => {
		const { deleteBuyerSupplierRelationship } = this.props;

		this.setState({ removingFacilityId: supplierFacilityId });
		deleteBuyerSupplierRelationship(supplierFacilityId)
			.then(() => {
				this.refreshSupplierPrivateNetwork();
				message.success(`Deleted supplier from your private network.`);
			})
			.finally(() => this.setState({ removingFacilityId: null }));
	};

	showSupplierPrivateNetworkEditModal = (record) => {
		this.setState({
			supplierPrivateNetworkEditFormVisible: true,
			supplierFacilityId: record.supplierFacilityId,
			supplierFacility: record,
		});
	};

	// Opens the add-supplier flow, remembering which supplier type the user chose so
	// the created supplier carries that type and the modal title reflects it.
	openAddSupplierModal = (supplierType) => {
		this.setState({ addSupplierType: supplierType, infoModalVisible: true });
	};
	handleCloseInfoModal = () => {
		this.setState({ infoModalVisible: false });
	};

	submitNewSupplierInfo = (supplier) => {
		const { fetchSuppliers } = this.props;
		this.setState({ supplierInfo: supplier }, () => {
			if (supplier.primaryContactEmail) {
				Promise.all([
					fetchSuppliers(
						supplier.name,
						supplier.primaryContactEmail,
						SUPPLIER_PRIVATE_NETWORKS_SEARCH_TARGET_COLLECTION
					),
				]).then((records) => {
					if (nullSafeGetOrElse('0.length', records, 0) > 0) {
						this.setState({
							selectSuppliers: records[0],
							selectSupplierModalVisible: true,
						});
					} else {
						this.setState({
							selectSuppliers: [],
						});
						this.handleAddNewSupplier();
					}
				});
			} else {
				// Supplier name and email not provided. so adding self managed supplier
				this.handleAddNewSupplier();
			}
		});
	};

	handleAddNewSupplier = () => {
		const { addNewSupplier } = this.props;
		const { supplierInfo, addSupplierType } = this.state;
		// Classification happens at creation: isInternalTeam makes the supplier company private to
		// this buyer, isLandlord sets the flag on the facility. Neither can be changed afterwards,
		// and the API rejects both being true.
		addNewSupplier({ ...supplierInfo, ...getSupplierTypeFlags(addSupplierType) }).then((record) => {
			this.setState({ supplierFacilityId: record.id }, () => {
				this.handleSupplierSelected(record);
			});
		});
	};

	handleBackSelectSupplierModal = () => {
		this.setState({ selectSupplierModalVisible: false, infoModalVisible: true });
	};

	handleCloseSelectSupplierModal = () => {
		this.setState({ selectSupplierModalVisible: false, infoModalVisible: false });
	};

	handleSupplierSelected = (record) => {
		this.setState({ selectSupplierModalVisible: false, infoModalVisible: false });
		this.showSupplierPrivateNetworkCreateModal(record);
	};

	handleExistingSupplierSelected = (record) => {
		this.setState({ selectSupplierModalVisible: false, infoModalVisible: false });
		this.showSupplierPrivateNetworkEditModal(record);
	};

	handleSimilarSupplierSelected = (supplier, isAlreadyInNetwork) => {
		this.setState({ supplierFacilityId: supplier.id }, () => {
			if (isAlreadyInNetwork) {
				// The edit flow keys off `supplierFacilityId`, which the search records don't carry.
				this.handleExistingSupplierSelected({ ...supplier, supplierFacilityId: supplier.id });
			} else {
				this.handleSupplierSelected(supplier);
			}
		});
	};

	handleInviteMySupplier = () => {
		this.handleAddNewSupplier();
		this.handleCloseSelectSupplierModal();
	};

	getRankFilters = () => {
		const { supplierPrivateNetworks } = this.props;
		const filters = nullSafeGetOrElse(
			`${SUPPLIER_PRIVATE_NETWORKS_INDEX_TARGET_COLLECTION}.filters`,
			supplierPrivateNetworks,
			{}
		);

		return {
			[FILTER_CONFIG_NAMES.LOCATION]: nullSafeGet('locationIds', filters),
			[FILTER_CONFIG_NAMES.PROBLEM_TYPE]: nullSafeGet('problemTypeIds', filters),
			// Export what the tab shows. Normalising through the helpers rather than copying the two
			// keys keeps All as "no flags" and each type tab as the same explicit pair the list sends.
			...getSupplierTypeFlags(getSupplierTypeFromFlags(filters)),
		};
	};

	onDownloadSuppliers = () => {
		this.setState({ downloading: true });
		const { downloadFirstRankSuppliers } = this.props;
		const filters = this.getRankFilters();

		downloadFirstRankSuppliers(filters)
			.catch((err) => message.error(err))
			.finally(() => this.setState({ downloading: false }));
	};

	onDownloadAllSuppliers = () => {
		this.setState({ downloading: true });
		const { downloadAllSuppliers, supplierPrivateNetworks } = this.props;
		const filters = nullSafeGetOrElse(
			`${SUPPLIER_PRIVATE_NETWORKS_INDEX_TARGET_COLLECTION}.filters`,
			supplierPrivateNetworks,
			{}
		);

		downloadAllSuppliers(filters)
			.catch((err) => message.error(err))
			.finally(() => this.setState({ downloading: false }));
	};

	render() {
		const {
			supplierPrivateNetworks,
			locations,
			problemTypes,
			fetchLocations,
			fetchProblemTypes,
			clearAndUpdateFilters,
			updateSupplierPrivateNetworksFilters,
			currentUser,
			userType,
		} = this.props;

		const onRow = (record) => ({
			onClick: () => this.goToSupplierDetailPage(record.supplierFacilityId),
		});

		const isAddingLandlord = this.state.addSupplierType === LANDLORD_SUPPLIERS_TAB_KEY;

		const selectedSupplierType = getSupplierTypeFromFlags(
			nullSafeGetOrElse(
				`${SUPPLIER_PRIVATE_NETWORKS_INDEX_TARGET_COLLECTION}.filters`,
				supplierPrivateNetworks,
				{}
			)
		);

		const filterConfig = getPrivateNetworkFilterConfig({
			locations,
			problemTypes,
			fetchLocations,
			fetchProblemTypes,
			updateFilters: updateSupplierPrivateNetworksFilters,
			targetCollectionName: SUPPLIER_PRIVATE_NETWORKS_INDEX_TARGET_COLLECTION,
			filterTargetCollectionName: 'supplierPrivateNetworksAdvancedFilters',
			// "Self Managed" applies to every supplier type except internal teams.
			includeSelfManagedStatus: selectedSupplierType !== INTERNAL_SUPPLIERS_TAB_KEY,
		});

		const columns = [
			{
				title: 'Name',
				dataIndex: 'name',
				render: (text, record) => {
					const spendCategories = nullSafeGetOrElse(
						'supplierFacility.categoryNames',
						record,
						''
					).split(',');
					return (
						<div style={{ display: 'flex', alignItems: 'center', minWidth: 320 }}>
							<div style={{ marginRight: 16 }}>
								{nullSafeGet('supplierFacility.logoURL', record) ? (
									<FlexibleImageAvatar
										displayName={text}
										showPopover={false}
										popoverText={text}
										squareMode={true}
										width="120px"
										height="80px"
										imageUrl={nullSafeGet('supplierFacility.logoURL', record)}
									/>
								) : (
									<FlexibleImageAvatar
										displayName={
											nullSafeGet('supplierFacilityAlias', record) ||
											nullSafeGet('supplierFacility.name', record)
										}
										showPopover={false}
										popoverText={
											nullSafeGet('supplierFacilityAlias', record) ||
											nullSafeGet('supplierFacility.name', record)
										}
										squareMode={true}
										width="120px"
										height="80px"
										imageUrl="https://s3.amazonaws.com/emptor-data-assets/images/empty-state/icons8-city-filled-100.png"
									/>
								)}
							</div>
							<div>
								<div
									style={{
										fontSize: 18,
										wordBreak: 'break-word',
									}}
								>
									{nullSafeGet('supplierFacilityAlias', record) ||
										nullSafeGet('supplierFacility.name', record)}
								</div>
								<div style={{ marginBottom: 0, fontSize: 14 }}>
									{record.relationshipStatus && (
										<div
											className={`text-base capitalize text-gray-500 ${
												record.relationshipStatus === 'connected' ? 'text-green-500' : ''
											}`}
										>
											{record.relationshipStatus === 'SelfManaged'
												? 'Self Managed'
												: record.relationshipStatus}
										</div>
									)}
									<div
										style={{ wordBreak: 'normal', whiteSpace: 'normal', color: 'rgba(0,0,0,0.45)' }}
									>
										{spendCategories
											.map((categoryName) => capitalizeEachWord(categoryName))
											.slice(0, 2)
											.join(', ')}
										{spendCategories.length > 3 ? ' and more' : null}
									</div>
								</div>
								<AddressDisplay
									hidePostcode={true}
									hideCountry={true}
									hideStreetAddress={true}
									address={record.primaryAddress}
									style={{
										color: 'rgba(0,0,0,0.45)',
									}}
								/>
								{nullSafeGet('averageRating', record) ? (
									<RatingComponent
										rating={nullSafeGet('averageRating', record)}
										numRatings={nullSafeGet('numRatings', record)}
										tags={nullSafeGet('reviewTagsWithCount', record)}
										tagCountToShow={3}
									/>
								) : null}
							</div>
						</div>
					);
				},
			},
			{
				title: 'Locations Served',
				dataIndex: 'locationNames',
				render: (text, record) => (
					<div>
						{nullSafeGet('locationNames.0', record) ? (
							<div>
								Serving locations: <br /> {stringArrToList(record.locationNames.map((l) => l))}
							</div>
						) : (
							<div>
								{record.locationIds ? 'Assigned to all locations' : 'No locations assigned'}
							</div>
						)}
					</div>
				),
			},
			{
				title: 'Actions',
				dataIndex: 'id',
				render: (text, record) => (
					<AccessPermissionChecker name={PERMISSION_NAMES.EDIT_SUPPLIER_NETWORK_ASSOCIATION}>
						<OWButtonWithSupplierManagedLock
							onClick={(e) => {
								e.stopPropagation();
								e.preventDefault();
								this.showSupplierPrivateNetworkEditModal(record);
							}}
						>
							Edit Network
						</OWButtonWithSupplierManagedLock>
					</AccessPermissionChecker>
				),
			},
			{
				title: 'Delete Actions',
				dataIndex: 'supplierFacilityId',
				render: (text, record) => (
					<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_SUPPLIERS}>
						<Popconfirm
							title={'Are you sure, you want remove this supplier?'}
							onConfirm={(e) => {
								stopDefaultEvents(e);
								this.removeFromSupplierPrivateNetwork(record.supplierFacilityId);
							}}
							onCancel={(e) => stopDefaultEvents(e)}
							okText="Yes"
						>
							<OWButtonWithSupplierManagedLock
								loading={this.state.removingFacilityId === record.supplierFacilityId}
								danger
								ghost
								onClick={(e) => stopDefaultEvents(e)}
							>
								Remove Supplier
							</OWButtonWithSupplierManagedLock>
						</Popconfirm>
					</AccessPermissionChecker>
				),
			},
		];

		const canShowDownloadFirstRankSupplier =
			userType === ROLE_TYPES.BUYER || isInternalTech(currentUser);

		const downloadMenu = (
			<Menu>
				<Menu.Item onClick={this.onDownloadSuppliers}>Export Rank 1 suppliers</Menu.Item>
				<Menu.Item onClick={this.onDownloadAllSuppliers}>Export supplier details</Menu.Item>
			</Menu>
		);

		const addSupplierMenu = (
			<Menu>
				<Menu.Item onClick={() => this.openAddSupplierModal(THIRD_PARTY_SUPPLIERS_TAB_KEY)}>
					{SUPPLIER_TYPE_LABELS[THIRD_PARTY_SUPPLIERS_TAB_KEY]}
				</Menu.Item>
				<Menu.Item onClick={() => this.openAddSupplierModal(INTERNAL_SUPPLIERS_TAB_KEY)}>
					{SUPPLIER_TYPE_LABELS[INTERNAL_SUPPLIERS_TAB_KEY]}
				</Menu.Item>
				<Menu.Item onClick={() => this.openAddSupplierModal(LANDLORD_SUPPLIERS_TAB_KEY)}>
					{SUPPLIER_TYPE_LABELS[LANDLORD_SUPPLIERS_TAB_KEY]}
				</Menu.Item>
			</Menu>
		);

		return (
			<Content className="privateNetworkIndexPage" style={{ padding: '0 0.5em' }}>
				{/*<ScrollToTopOnMount/>*/}
				{/*<BackTop/>*/}
				<SupplierPrivateNetworkCreateForm
					userType={userType}
					wrappedComponentRef={this.saveFormRef('supplierPrivateNetworkCreateForm')}
					visible={this.state.supplierPrivateNetworkCreateFormVisible}
					supplierFacilityId={this.state.supplierFacilityId}
					supplierFacility={this.state.supplierFacility}
					onCancel={this.handleSupplierPrivateNetworkCreateCancel}
					onSubmit={this.handleSupplierPrivateNetworkCreateSubmit}
					loading={this.state.creatingPrivateNetwork}
				/>
				{this.state.supplierPrivateNetworkEditFormVisible && (
					<SupplierPrivateNetworkEditForm
						userType={userType}
						wrappedComponentRef={this.saveFormRef('supplierPrivateNetworkEditForm')}
						visible
						supplierFacilityId={this.state.supplierFacilityId}
						supplierFacility={this.state.supplierFacility}
						onCancel={this.handleSupplierPrivateNetworkEditCancel}
						onSubmit={this.handleSupplierPrivateNetworkEditSubmit}
						loading={this.state.updatingPrivateNetwork}
					/>
				)}
				<Modal
					//Select Supplier Modal
					width={800}
					title={
						<div style={{ width: '100%', position: 'relative', display: 'block' }}>
							<span>{getSimilarSuppliersTitle(this.state.selectSuppliers.length)}</span>
						</div>
					}
					footer={
						<div style={{ display: 'block', position: 'relative', width: '100%', height: '32px' }}>
							<div
								style={{
									display: 'inline-block',
									position: 'absolute',
									left: '0px',
									top: '0px',
									verticalAlign: 'bottom',
								}}
							>
								<Button onClick={this.handleBackSelectSupplierModal}>Back</Button>
							</div>
							<div
								style={{
									display: 'inline-block',
									position: 'absolute',
									right: '0px',
									top: '0px',
									verticalAlign: 'bottom',
								}}
							>
								<Button onClick={this.handleInviteMySupplier} type="primary">
									No, Invite My Supplier
								</Button>
							</div>
						</div>
					}
					bodyStyle={{ overflowY: 'scroll' }}
					closable={false}
					onCancel={this.handleCloseInfoModal}
					visible={this.state.selectSupplierModalVisible}
					destroyOnClose={true}
				>
					<SimilarSuppliersPanel
						suppliers={this.state.selectSuppliers}
						existingSupplierIds={Object.keys(
							nullSafeGetOrElse('distinctRecords', supplierPrivateNetworks, {})
						)}
						onSelectSupplier={this.handleSimilarSupplierSelected}
						wrapperClassName="min-h-[560px]"
					/>
				</Modal>

				<Modal
					//Supplier Contact info modal
					width={640}
					title={<span>{`Add ${SUPPLIER_TYPE_LABELS[this.state.addSupplierType]}`}</span>}
					footer={null}
					closable={false}
					onCancel={this.handleCloseInfoModal}
					visible={this.state.infoModalVisible}
					destroyOnClose={true}
				>
					<InviteSupplierForm
						submit={this.submitNewSupplierInfo}
						cancel={this.handleCloseInfoModal}
						// A landlord is just a name on the record — no contact is invited to OpenWrench,
						// so the contact fields would collect details nothing acts on.
						nameOnly={isAddingLandlord}
						nameLabel={isAddingLandlord ? 'Landlord Name' : undefined}
						namePlaceholder={isAddingLandlord ? 'Acme Property Group' : undefined}
					/>
				</Modal>
				{/* Grid with a 12px row gap, as on the work order index header: the gap only appears
				    between rows that actually render, so it costs nothing when no filters are applied
				    and SelectedFilters returns null. */}
				<div className="grid gap-y-3">
					{/* 4px of breathing room above and below the whole control row. Padding here rather
					    than on SubnavBar, which is shared, and rather than inside the row, so the sub-tab
					    strip still stretches to the controls' height and keeps its baseline aligned. */}
					<Row className="py-1" style={{ margin: '0em ' }}>
						<Col span={24}>
							<SubnavBar
								// No minWidth override: the left group needs its automatic minimum size so the
								// bar can tell when the actions no longer fit beside it and wrap them below.
								rightStyle={{ flexShrink: 0 }}
								left={
									// 16px between the tab strip and the controls, matching the right-hand group.
									// Wraps rather than overflows when the row runs out of width: the tab strip
									// keeps its own line and the search + Filters drop 12px beneath it — the same
									// row gap the grid puts between this row and the filter pills.
									<div className="flex flex-row flex-wrap items-center gap-x-4 gap-y-3">
										<OWSubTabs
											className="networkTypeTabs"
											activeKey={selectedSupplierType}
											onChange={this.handleSupplierTypeTabChange}
											tabs={SUPPLIER_TYPE_SUB_TABS}
										/>
										<AdvancedFilters
											updateFilters={updateSupplierPrivateNetworksFilters}
											filterConfig={filterConfig}
											inputParamName={'supplierFacilityAlias'}
											filtersTargetCollectionName={
												SUPPLIER_PRIVATE_NETWORKS_INDEX_TARGET_COLLECTION
											}
											clearAndUpdateFilters={clearAndUpdateFilters}
											filtersStateSlice={supplierPrivateNetworks}
											// The supplier-type tab is not a user filter, so pass it as a
											// pre-applied filter: Clear Filters ignores it and retains the
											// current tab after clearing.
											preAppliedFilters={getSupplierTypeFlags(selectedSupplierType)}
											initialFilters={this.initialFilters}
											// 12px between the search box and the Filters button, up from the
											// shared default of 8px, to match this header's looser spacing.
											wrapperStyle={{ gap: '12px' }}
										/>
									</div>
								}
								right={
									// 12px between every action, matching the gap between the controls on the
									// left. The items used to carry their own 16px right margins instead.
									<div className="flex flex-row items-center gap-3">
										<SuppliersPendingApprovalsIndicator />
										{canShowDownloadFirstRankSupplier ? (
											<>
												{isAdminUser(currentUser) ? (
													<FirstRankSupplierUploadButton getRankFilters={this.getRankFilters} />
												) : null}
												<Dropdown overlay={downloadMenu}>
													<OWButtonWithSupplierManagedLock
														key={1}
														size="large"
														className="inline-block-visible-md"
													>
														<div className="flex flex-row items-center">
															{this.state.downloading ? (
																<Spin size="small" />
															) : (
																<DownloadOutlined />
															)}
															<DownOutlined className="ml-2" />
														</div>
													</OWButtonWithSupplierManagedLock>
												</Dropdown>
											</>
										) : null}
										<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_SUPPLIERS}>
											<Dropdown overlay={addSupplierMenu}>
												<OWButtonWithSupplierManagedLock
													size="large"
													type="primary"
													className="inline-block-visible-md"
												>
													<div className="flex flex-row items-center">
														<span>Add</span>
														<DownOutlined className="ml-2" />
													</div>
												</OWButtonWithSupplierManagedLock>
											</Dropdown>
										</AccessPermissionChecker>
										<SuppliersRequestToAddButton />
									</div>
								}
							/>
						</Col>
					</Row>
					<SelectedFilters
						updateFilters={(filters) =>
							updateSupplierPrivateNetworksFilters(
								filters,
								SUPPLIER_PRIVATE_NETWORKS_INDEX_TARGET_COLLECTION
							)
						}
						filterValues={nullSafeGetOrElse(
							`${SUPPLIER_PRIVATE_NETWORKS_INDEX_TARGET_COLLECTION}.filters`,
							supplierPrivateNetworks,
							{}
						)}
						filterConfig={filterConfig}
					/>
				</div>
				<Row style={{ margin: '0.5em 0px ' }}>
					<Col span={24}>
						<Card bodyStyle={{ padding: 8 }}>
							<PaginatedReduxTable
								emptyState={
									<EmptyState
										graphic={
											<img
												style={{ marginBottom: 8 }}
												src="https://s3.amazonaws.com/mock-data-assets/categories/images/cactus.svg"
												alt="It's a little lonely in here."
											/>
										}
										headline={"It's a little lonely in here."}
										body={
											<div style={{ textAlign: 'center' }}>
												<div style={{ maxWidth: 440, marginBottom: 16 }}>
													Looks like your team has not added any supplier in your private network
													yet.
												</div>
											</div>
										}
									/>
								}
								updateQueryParams={true}
								collectionName="supplier_private_networks"
								useDistinctCollection={true}
								onRow={onRow}
								showHeader={false}
								targetCollectionName={SUPPLIER_PRIVATE_NETWORKS_INDEX_TARGET_COLLECTION}
								columns={columns}
								keyAccessor={(el) => el.supplierFacilityId}
								initialFilters={this.initialFilters}
								initialPagination={this.initialPagination}
								// hiddenPagination={pagination.getOther()}
								fetchData={
									userType === ROLE_TYPES.SUPPLIER
										? supplierPrivateNetworksV2ForSupplier
										: supplierPrivateNetworksV2ForBuyer
								}
							/>
						</Card>
					</Col>
				</Row>
			</Content>
		);
	}
}

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
	locations: state.locations,
	problemTypes: state.problem_types,
	supplierPrivateNetworks: state.supplier_private_networks,
	selectSuppliers: state.selectSuppliers,
	userType: (state as any).session.userType,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	createSupplierPrivateNetworkBulk: (entities) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? createSupplierPrivateNetworkBulkForSupplier(entities)
				: createSupplierPrivateNetworkBulkForBuyer(entities)
		),
	updateSupplierPrivateNetworksFilters: (filters, targetCollection) =>
		dispatch(
			SUPPLIER_PRIVATE_NETWORKS_CRUD_ACTION_CREATORS.updateFilters(filters, targetCollection)
		),
	clearAndUpdateFilters: (filters, targetCollectionName) =>
		dispatch(
			SUPPLIER_PRIVATE_NETWORKS_CRUD_ACTION_CREATORS.clearAndUpdateFilters(
				filters,
				targetCollectionName
			)
		),
	fetchLocations: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? locationsRestCrudThunksForSupplier.readLite(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
				: locationsRestCrudThunksForBuyer.readLite(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
		),
	fetchSuppliers: (name, email, targetCollectionName) =>
		dispatch(
			fetchSuppliersForBuyers(ownProps.userType)(name, email)('supplierPrivateNetworksSearch')
		),
	addNewSupplier: (entity) => dispatch(addNewSupplierForBuyers(ownProps.userType)(entity)),
	updateGroupedSupplierPrivateNetwork: (id, entity) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? supplierPrivateNetworkGroupedUpdateForSupplier(id)(entity)
				: supplierPrivateNetworkGroupedUpdateForBuyer(id)(entity)
		),
	updateSupplierPrivateNetworkV2: (id, entity) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? supplierPrivateNetworkV2UpdateForSupplier(id)(entity)
				: supplierPrivateNetworkV2UpdateForBuyer(id)(entity)
		),
	deleteBuyerSupplierRelationship: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? deleteBuyerSupplierRelationshipBySupplierFacilityIdForSupplier(id)
				: deleteBuyerSupplierRelationshipBySupplierFacilityIdForBuyer(id)
		),
	fetchSupplierPrivateNetworkV2: (
		additionalParams,
		targetCollectionName,
		pagination,
		sorting,
		filters
	) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? supplierPrivateNetworksV2ForSupplier(
						additionalParams,
						targetCollectionName,
						pagination,
						sorting,
						filters
				  )
				: supplierPrivateNetworksV2ForBuyer(
						additionalParams,
						targetCollectionName,
						pagination,
						sorting,
						filters
				  )
		),
	inviteSupplierUser: (supplierFacilityId, fromEmail, toEmail, firstName, lastName) =>
		dispatch(
			inviteSupplierUserFromBuyer(ownProps.userType)(
				supplierFacilityId,
				fromEmail,
				toEmail,
				firstName,
				lastName
			)
		),
	downloadFirstRankSuppliers: (params) =>
		dispatch(downloadFirstRankSuppliers(ownProps.userType)(params)),
	fetchProblemTypes: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) => {
		const fnToCall =
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? problemTypesHeirarchicalForSupplier
				: problemTypesHeirarchicalForBuyer;
		return dispatch(
			fnToCall(params, targetCollectionName, pagination, sorting, filters, addToTargetCollection)
		);
	},
	downloadAllSuppliers: (params, filters) =>
		dispatch(downloadAllSuppliers(ownProps.userType)(params, filters)),
});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(PrivateNetworkIndexPage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
